import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06e596b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field has-addons" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["id", "checked", "onChange"]
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 1,
  class: "control"
}
const _hoisted_6 = ["value", "onChange"]
const _hoisted_7 = { class: "control" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-minus" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "help is-danger mt-0"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-plus" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newList, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "field",
        key: i
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.field.subtype === 'bool')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("input", {
                  id: `${_ctx.fieldId}-${i}`,
                  type: "checkbox",
                  class: "switch is-rounded",
                  checked: item === true,
                  onChange: ($event: any) => (_ctx.updateItem(i, ($event.target as HTMLInputElement).checked))
                }, null, 40, _hoisted_3),
                _createElementVNode("label", {
                  class: "label",
                  for: `${_ctx.fieldId}-${i}`
                }, null, 8, _hoisted_4)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("input", {
                  class: _normalizeClass(["input", { 'is-danger': _ctx.itemError[i] }]),
                  value: item,
                  onChange: ($event: any) => (_ctx.updateItem(i, ($event.target as HTMLInputElement).value))
                }, null, 42, _hoisted_6)
              ])),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: "button is-danger is-outlined",
              title: "Remove item from list",
              onClick: ($event: any) => (_ctx.removeItem(i))
            }, _hoisted_10, 8, _hoisted_8)
          ])
        ]),
        (_ctx.itemError[i])
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.itemError[i]), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("p", null, [
      _createElementVNode("a", {
        class: "button is-primary mt-1",
        title: "Add new row",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
      }, _hoisted_13)
    ])
  ]))
}